module.exports = __webpack_public_path__ + "static/media/boat-img-32.de409b23.jpg";